import React from 'react';
import { XCircle, X } from 'lucide-react';

interface ErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
}

const ErrorModal: React.FC<ErrorModalProps> = ({ 
  isOpen, 
  onClose, 
  title = 'Booking Failed',
  message = 'There was an error processing your reservation. Please try again or contact us directly.'
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black bg-opacity-75" onClick={onClose}></div>
      
      <div className="relative bg-gray-900 border-2 border-red-500 rounded-lg p-8 max-w-md w-full shadow-2xl">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors"
        >
          <X className="w-6 h-6" />
        </button>

        <div className="text-center">
          <div className="mb-4 flex justify-center">
            <XCircle className="w-16 h-16 text-red-500" />
          </div>
          
          <h2 className="text-2xl font-bold text-red-500 mb-4 font-display">
            {title}
          </h2>
          
          <p className="text-gray-300 mb-6">
            {message}
          </p>

          <button
            onClick={onClose}
            className="bg-red-500 text-white px-8 py-3 rounded-full font-semibold hover:bg-red-600 transition-all"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
